import { createStore } from "owa-satcheljs";
import type EmitterStore from "./schema/EmitterStore";

var initialEmitterStore: EmitterStore = {
    emitters: {},
};
const defaultExport: () => EmitterStore = createStore<EmitterStore>("resizeEmitters", initialEmitterStore);
export default defaultExport;
